import { useParams } from 'react-router-dom';
import { getTeacherWorkloadsUrl } from 'services/navigation';
import { useGetTeacherWorkloadByIdQuery } from 'shared/api';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';
import type { TeacherWorkloadPageParams } from 'services/navigation';

export const useTeacherWorkloadPage = () => {
  const { teacherWorkloadId } = useParams<TeacherWorkloadPageParams>();
  const id = teacherWorkloadId ? Number(teacherWorkloadId) : NaN;
  const skip = !Number.isFinite(id);

  const {
    data: teacherWorkload,
    isLoading,
    isFetching,
  } = useGetTeacherWorkloadByIdQuery(id, {
    skip,
  });

  const breadcrumbsLoading = !skip && (isLoading || isFetching);

  const breadcrumbs = [
    homeBreadcrumbItem,
    {
      title: 'Нагрузка учителя',
      url: getTeacherWorkloadsUrl(),
    },
    {
      title: teacherWorkload?.code ?? '',
      url: '',
    },
  ];

  return {
    breadcrumbs,
    breadcrumbsLoading,
    teacherWorkload,
    isPageLoading: !skip && !teacherWorkload && (isLoading || isFetching),
    isTeacherWorkloadRefetching: isFetching && !isLoading,
  };
};
